module.exports = __webpack_public_path__ + "media/img/event/logo/wells-f4822b3d28ba70d31ac31aaa31971ad6.jpg";